import { cn } from '@/utils/functions';
import { Skeleton } from '@bsf/force-ui';

const ActionItemsSkeleton = () => {
	return (
		<>
			<div className="border-0.5 border-solid border-border-subtle rounded-lg">
				<Skeleton
					variant="rectangular"
					className="w-full h-14 rounded-b-none rounded-t-lg"
				/>

				<div className="px-4">
					{ Array( 4 )
						.fill( 0 )
						.map( ( _, index ) => (
							<div
								key={ `step-skeleton-${ index }` }
								className={ cn(
									'py-5 flex items-center gap-3',
									index === 3
										? ''
										: 'border-b-0.5 border-solid border-border-subtle'
								) }
							>
								<Skeleton
									variant="circular"
									className="w-6 h-6"
								/>
								<div className="flex-1">
									<Skeleton
										variant="rectangular"
										className="w-2/3 h-5"
									/>
								</div>
								<Skeleton
									variant="rectangular"
									className="w-[104px] h-8"
								/>
							</div>
						) ) }
				</div>
			</div>

			{ Array( 4 )
				.fill( 0 )
				.map( ( _, index ) => (
					<Skeleton
						key={ `skeleton-${ index }` }
						variant="rectangular"
						className="w-full h-14 rounded-lg"
					/>
				) ) }
		</>
	);
};

export default ActionItemsSkeleton;
